module.exports = __webpack_public_path__ + "img/tag5.1cb1a84f.png";